<template lang="pug">
.v-app-widget.app-widget(v-if="data" :id="data?.id")
	template(v-if="isTablet && button")
		a.btn(:href="computedAppLink" :class="button.className" target="_blank") {{button.text}}
	template(v-else="Скачать")
		a.app-widget__item(v-if="data.appstore" :href="data.appstore.link" target="_blank")
			v-svg-icon.app-widget__item-icon(icon="appstore")
		a.app-widget__item(v-if="data.googleplay" :href="data.googleplay.link" target="_blank")
			v-svg-icon.app-widget__item-icon(icon="googleplay")
		a.app-widget__item(v-if="data.appgallery" :href="data.appgallery.link" target="_blank")
			v-svg-icon.app-widget__item-icon(icon="appgallery")
		button.app-widget__item(v-if="data.qr" type="button" @click="openModal = true")
			v-svg-icon.app-widget__item-icon(icon="qr")
		teleport(to="body")
			v-modal(v-if="data.qr && openModal" @close="() => this.openModal = null")
				.app-widget__qr
					img.app-widget__qr-img(v-if="data.qr.src" :src="data.qr.src")
					.app-widget__qr-text(v-if="data.qr.text") {{data.qr.text}}
</template>

<script>

import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import {mapGetters} from "vuex";

export default {

	mixins: [
		isMobMixin
	],

	props: {
		button: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			openModal: false,
			deviceData: window.deviceData
		}
	},

	computed: {
		...mapGetters({
			getAppWidget: 'appWidget/getAppWidget'
		}),

		computedAppLink() {
			let result;
			if (this.data && this.deviceData) {
				if (this.deviceData.deviceOS === 'ios') {
					result = this.data.appstore.link;
				} else if (this.deviceData.deviceOS === 'huawei') {
					result = this.data.appgallery.link;
				} else {
					result = this.data.googleplay.link;
				}
			}
			return result;
		},

		data() {
			return this.getAppWidget
		}
	}
}

</script>